export default __webpack_public_path__ + "static/media/empty-list.6415106d.svg";